var validationUtilities = {
	whitelistVisitor: function (whitelist, data, f, key, isArrayMember) {
		var isWildcardMatch = key + '.*' in whitelist;

		if (key !== null && typeof key !== 'undefined' && !(key in whitelist) && !isWildcardMatch) {
			var invalidResult = f(key, false, data, isArrayMember);

			if (invalidResult === false) {
				return false;
			}
		} else {
			if (key !== null && typeof key !== 'undefined') {
				var validResult = f(key, true, data, isArrayMember);

				if (validResult === false) {
					return false;
				}
			}

			if (typeof data === 'object') {
				var nextPrefix = isWildcardMatch ? key + '.*' : key !== null && typeof key !== 'undefined' ? key : '';

				if (data instanceof Array) {
					for (var i = 0, l = data.length; i < l; i++) {
						if (validationUtilities.whitelistVisitor(whitelist, data[i], f, nextPrefix, true) === false) {
							return;
						}
					}
				} else if (key === null || typeof key === 'undefined' || !whitelist[key] || !whitelist[key].freeform) {
					for (var k in data) {
						if (
							validationUtilities.whitelistVisitor(whitelist, data[k], f, isWildcardMatch ? nextPrefix : (nextPrefix ? nextPrefix + '.' : '') + k) === false
						) {
							return;
						}
					}
				}
			}
		}
	},

	matchesWhitelist: function (whitelist, data) {
		var valid = true;

		validationUtilities.whitelistVisitor(whitelist, data, function (key, isValid) {
			if (!isValid) {
				valid = false;

				return false;
			}
		});

		return valid;
	}
};

module.exports = validationUtilities;
